const icon = require('vue-svgicon');
icon.register({
    'star': {
        width: 30,
        height: 30,
        viewBox: '0 0 30 30',
        data: `<path d="M9.88106 9.0568L13.7773 0.79541C14.2775 -0.265137 15.7225 -0.265137 16.2227 0.79541L20.1189 9.0568L28.8322 10.3897C29.9502 10.5608 30.3957 11.999 29.5864 12.8241L23.2826 19.2502L24.7703 28.3285C24.9614 29.4944 23.7921 30.3834 22.7918 29.8328L15 25.5442L7.2082 29.8328C6.2079 30.3834 5.03863 29.4944 5.22968 28.3285L6.71738 19.2502L0.413626 12.8241C-0.39574 11.999 0.0498298 10.5608 1.16778 10.3897L9.88106 9.0568Z" _fill="#000"/>`,
    },
});
